/**
 * Helper to decalre no op value
 *
 * @remarks
 * [Definition](https://www.noop.com.au/noop-meaning/#:~:text=The%20term%20No%2Dop%20(NOP,instructions%20or%20%E2%80%9Ctiming%E2%80%9D%20purposes.) • [Reference](https://lodash.com/docs/4.17.15#noop)
 *
 * @returns undefined
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: ()=>_default
});
const _noop = ()=>{};
const _default = _noop;
